import { dayjs } from 'date';
import { translate } from 'i18n';

export const DEFAULT_DAYS = dayjs().add(7, 'days');
export const DEFAULT_OPTIONS = [
  {
    label: translate('backlog.timeFilter.options.next2Days', { namespace: 'features' }),
    value: dayjs().add(2, 'days'),
  },
  {
    label: translate('backlog.timeFilter.options.next7Days', { namespace: 'features' }),
    value: dayjs().add(7, 'days'),
  },
  {
    label: translate('backlog.timeFilter.options.next14Days', { namespace: 'features' }),
    value: dayjs().add(14, 'days'),
  },
  {
    label: translate('backlog.timeFilter.options.last7Days', { namespace: 'features' }),
    value: dayjs().subtract(7, 'days'),
  },
  {
    label: translate('backlog.timeFilter.options.last30Days', { namespace: 'features' }),
    value: dayjs().subtract(30, 'days'),
  },
  {
    label: translate('backlog.timeFilter.options.last90Days', { namespace: 'features' }),
    value: dayjs().subtract(90, 'days'),
  },
];
